import React, { useState, useEffect, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "../../firebase-config";
import {db} from "../../firebase-config";
import {app} from "../../firebase-config";
import { async } from '@firebase/util';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where,getDoc } from "firebase/firestore";
import Cookies from 'universal-cookie';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {getAge} from "../../Helper";
import Moment from 'moment';
import Select from 'react-select';
import { Card } from 'react-bootstrap';
// export default class Login extends Component {
const SupportModule = (props) => {
  const [program,setProgram] = useState([]);

    console.log(props.userData.club_id)
    const getPrograms = async () => {
      const docRef = doc(db, "clubs", props.userData.club_id);
      await getDoc(docRef).then((docSnap)=>{
        if (docSnap.exists()) {
          console.log(docSnap.data());
          setProgram(docSnap.data());
        }else {
          console.log("No such document");
        }
      });
    }
    useEffect(() => {
      getPrograms();
      // Notice the empty dependency array, there to make sure the effect is only run once when the component mounts
    }, []);

  // user.userHome.user.email <- getting users
    return (
      <div className='row'>
        <div className='col-lg-6'>
        <Card>
          <Card.Body>
            <Card.Title className='bg-info'><h2>Contact Information</h2></Card.Title>
            <div>
                club name: <b>{program.club_name}</b><br></br>
                Address: <b>{program.Address}, {program.City}, {program.State}, {program.ZIP}</b><br></br>
                Phone: <b>{program.phone}</b><br></br>
                Website: <b>{program.website}</b><br></br>
                Open Hours:<br></br>
                monday: <b>{program.monday_in} to {program.monday_out}</b><br></br>
                Tuesday: <b>{program.tuesday_in} to {program.tuesday_out}</b><br></br>
                Wednesday: <b>{program.wednesday_in} to {program.wednesday_out}</b><br></br>
                Thursday: <b>{program.thursday_in} to {program.thursday_out}</b><br></br>
                Friday: <b>{program.friday_in} to {program.friday_out}</b><br></br>
                Saturday: <b>{program.saturday_in} to {program.saturday_out}</b><br></br>
                Sunday: <b>{program.sunday_in} to {program.sunday_out}</b><br></br>
            </div>
          </Card.Body>
        </Card>
        </div>
      </div>
    )
  // }
}

export default SupportModule;